import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { STROLLEROPEDIA_MORE_ARTICLES } from 'mk/autogenerated/translations/ArticlesOfSection.ae00a7301c6adbc0983ac9762455cb80'
import { getArticleTitleAsString } from 'mk2/apps/blogs/containers/Article/Article.helpers';
import { articleUrl as blogsArticleUrl } from 'mk2/apps/blogs/utils';
import { STROLLERS_GUIDE_SECTION_RECENT } from 'mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSections.constants';
import { perSectionInitialState } from 'mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSections.reducers';
import ReviewBlogPostPreview, { ReviewBlogPostPreviewPlaceholder } from 'mk2/apps/wiki/components/ReviewBlogPostPreview';
import { getArticleBadges } from 'mk2/components/Badge';
import { Btn, BtnType } from 'mk2/components/Btn';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { cacheLast } from 'mk2/helpers/cache';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { BlogPostEntity } from 'mk2/schemas';
import React from 'react';
import styles from './ArticlesOfSections.mscss';

interface OwnProps {
    title: string;
    titleIcon?: any;
    allArticles: BlogPostEntity[];
    articleIdsOfSection: number[];
    className?: string;
    errorMessage: string;
    hasMore: boolean;
    after: number;
    loadingState: LoadingState;
    sectionSlug: string;

    onLoad(section: string, after?: number, limit?: number);
}

type Props = OwnProps;

const LOAD_LIMIT = 20;

export class ArticlesOfSection extends React.Component<Props> {

    private articleBadgesCache = cacheLast(true);

    public render() {
        const { loadingState, articleIdsOfSection, title, titleIcon } = this.props;

        if (isSuccess(loadingState) && articleIdsOfSection?.length === 0) {
            return null;
        }

        return (
            <div className={styles.ArticlesOfSection}>
                <h2 className={styles.ArticlesOfSection__header}>
                    {titleIcon && (
                        <span className={styles.ArticlesOfSection__header__icon}>
                            <FontAwesomeIcon icon={titleIcon} />
                        </span>
                    )}
                    {title}
                </h2>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderLoadSuccess}
                    hasData={Boolean(articleIdsOfSection)}
                />
            </div>
        );
    }

    private renderInit = () => {
        const placeholderCount = this.props.sectionSlug === STROLLERS_GUIDE_SECTION_RECENT ? 7 : 3;
        return (
            <>
                {Array.from(Array(placeholderCount).keys()).map((index) => (
                    <ReviewBlogPostPreviewPlaceholder
                        key={index}
                        className={styles.ArticlesOfSection__article}
                        author={false}
                        badges
                    />
                ))}
            </>
        );
    };

    private renderLoadSuccess = () => {
        const { articleIdsOfSection, allArticles, hasMore, loadingState } = this.props;

        const articleBadges = this.articleBadgesCache(() => {
            const dict = {};
            for (const blogPostArticle of allArticles) {
                dict[blogPostArticle.id] = getArticleBadges(blogPostArticle.hashtagItems).renderedBadges;
            }
            return dict;
        }, [allArticles]);

        return (
            <>
                {articleIdsOfSection.map((articleId, index) => {
                    const blogPostArticle = allArticles.find((a) => a.id === articleId);
                    return (
                        <ReviewBlogPostPreview
                            key={index}
                            className={styles.ArticlesOfSection__article}
                            photo={blogPostArticle.photos?.length && blogPostArticle.photos[0]}
                            title={getArticleTitleAsString(blogPostArticle.titleAST)}
                            postUrl={blogsArticleUrl(blogPostArticle)}
                            badges={articleBadges[blogPostArticle.id]}
                            commentsCount={blogPostArticle.commentsCount}
                            likersCount={blogPostArticle.likeable.likesCount}
                        />
                    );
                })}
                {hasMore && (
                    <Btn
                        type={BtnType.BlueOutline}
                        label={STROLLEROPEDIA_MORE_ARTICLES}
                        onClick={this.loadNext}
                        hasSpinner={loadingState === LoadingState.LOADING}
                    />
                )}
            </>
        );
    };

    private load = () => {
        const { sectionSlug, onLoad } = this.props;
        onLoad(sectionSlug, null, LOAD_LIMIT);
    };

    private loadNext = () => {
        const { sectionSlug, onLoad, after } = this.props;
        onLoad(sectionSlug, after, LOAD_LIMIT);
    };
}
